import React, { useState } from 'react';

// Datos centralizados de todas las categorías y modelos
const categoriasData = [
    {
        id: 'follaje-3d',
        nombre: 'Follaje 3D',
        descripcion: 'Alto relieve y apariencia natural. Material: HDPE con filtro UV. Alta durabilidad en interior y exterior, sin mantenimiento.',
        carpeta: 'follaje-3d',
        grupos: [
            {
                titulo: null,
                modelos: [
                    { codigo: 'FOL034-01C', nombre: 'Helecho verde', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'follaje-3d-helecho-verde.png', agotado: true },
                    { codigo: 'FOL116-01C', nombre: 'Cipressus', formato: 'Panel 50 cm x 50 cm', peso: '2.7 kg por m²', imagen: 'follaje-3d-cipressus.png' },
                    { codigo: 'FOL032-01C', nombre: 'Magia', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'follaje-3d-magia.png', agotado: true },
                    { codigo: 'FOL086-02C', nombre: 'Multielementos', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'follaje-3d-multielementos.png', agotado: true },
                    { codigo: 'FOL085-01C', nombre: 'Florida', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'follaje-3d-florida.png' },
                    { codigo: 'FOL087-01C', nombre: 'Grecia', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'follaje-3d-grecia.png' }
                ]
            }
        ]
    },
    {
        id: 'follaje-premium',
        nombre: 'Follaje Premium',
        descripcion: 'La mayor variedad de diseños en panel y rollo. Material: HDPE con filtro UV. Alta durabilidad en interior y exterior, sin mantenimiento.',
        carpeta: 'follaje-premium',
        grupos: [
            {
                titulo: null,
                modelos: [
                    { codigo: 'FOL099-01D', nombre: 'Fantasy', formato: 'Panel 1 m x 1 m', peso: '2.5 kg por m²', imagen: 'premium-fantasy.jpg' },
                    { codigo: 'FOL086-01D', nombre: 'Boxwood Verde/Amarillo', formato: 'Panel 50 cm x 50 cm', peso: '580 g por m²', imagen: 'premium-boxwood-verde-amarillo.jpg' },
                    { codigo: 'FOL044-05D', nombre: 'Maple', formato: 'Rollo 1 m x 3 m', peso: '7.8 kg por m²', imagen: 'premium-maple.jpg' },
                    { codigo: 'FOL033-06D', nombre: 'Helecho japonés verde', formato: 'Rollo 1 m x 2 m', peso: '5 kg por m²', imagen: 'premium-helecho-japones-verde.jpg', agotado: true },
                    { codigo: 'FOL044-01D', nombre: 'Helecho japonés vino', formato: 'Panel 1 m x 3 m', peso: '7.8 kg por m²', imagen: 'premium-helecho-japones-vino.jpg', agotado: true },
                    { codigo: 'FOL047-05D', nombre: 'Arrayán purple', formato: 'Rollo 1 m x 2 m', peso: '4.3 kg por m²', imagen: 'premium-arrayan-purple.jpg' },
                    { codigo: 'FOL033-03D', nombre: 'Helecho', formato: 'Panel 1 m x 1 m', peso: '2.5 kg por m²', imagen: 'premium-helecho.jpg' },
                    { codigo: 'FOL085-02D', nombre: 'Azhar', formato: 'Rollo 1 m x 1 m', peso: '2.5 kg por m²', imagen: 'premium-azhar.jpg' },
                    { codigo: 'FOL032-04D', nombre: 'Trébol', formato: 'Rollo 1 m x 1 m', peso: '2.5 kg por m²', imagen: 'premium-trebol.jpg' },
                    { codigo: 'FOL085-06D', nombre: 'Tropical', formato: 'Rollo 1 m x 1 m', peso: '2.5 kg por m²', imagen: 'premium-tropical.jpg' },
                    { codigo: 'FOL043-03D', nombre: 'Bugambilia roja', formato: 'Rollo 1 m x 1 m', peso: '2.9 kg por m²', imagen: 'premium-bugambilia-roja.jpg' },
                    { codigo: 'FOL001-07D', nombre: 'Tulum', formato: 'Rollo 1 m x 1 m', peso: '3 kg por m²', imagen: 'premium-tulum.jpg' },
                    { codigo: 'FOL032-16D', nombre: 'Arroz', formato: 'Rollo 1 m x 1 m', peso: '2.8 kg por m²', imagen: 'premium-arroz.jpg' },
                    { codigo: 'FOL087-01D', nombre: 'Bugambilia sin flor', formato: 'Rollo 1 m x 3 m', peso: '8.9 kg por m²', imagen: 'premium-bugambilia-sin-flor.jpg', agotado: true },
                    { codigo: 'FOL032-10D', nombre: 'Hiedra', formato: 'Rollo 1 m x 2 m', peso: '5.1 kg por m²', imagen: 'premium-hiedra.jpg' },
                    { codigo: 'FOL001-03D', nombre: 'Jazmín', formato: 'Rollo 1 m x 1 m', peso: '2.4 kg por m²', imagen: 'premium-jazmin-1x1.jpg', agotado: true },
                    { codigo: 'FOL001-04D', nombre: 'Jazmín', formato: 'Rollo 1 m x 2 m', peso: '4.8 kg por m²', imagen: 'premium-jazmin-1x2.jpg' },
                    { codigo: 'FOL032-17D', nombre: 'Follaje en rollo', formato: 'Rollo 1 m x 5 m', peso: '12.5 kg por m²', imagen: 'premium-follaje-rollo-1x5.jpg' },
                    { codigo: 'FOL086-07D', nombre: 'Boxwood mix', formato: 'Panel 1 m x 1 m', peso: '2.8 kg por m²', imagen: 'premium-boxwood-mix.jpg' },
                    { codigo: 'FOL032-15D', nombre: 'Boxwood verde', formato: 'Panel 1 m x 1 m', peso: '3 kg por m²', imagen: 'premium-boxwood-verde.jpg' },
                    { codigo: 'FOL032-14D', nombre: 'Boxwood green', formato: 'Panel 50 cm x 50 cm', peso: '580 gr por pieza', imagen: 'premium-boxwood-green.jpg' },
                    { codigo: 'FOL115-03D', nombre: 'Arrayán White', formato: 'Rollo 1 m x 2 m', peso: '5.2 kg por rollo', imagen: 'premium-arrayan-white.jpg' },
                    { codigo: 'FOL032-09D', nombre: 'Hoja silvestre', formato: 'Rollo 1 m x 2 m', peso: '5.5 kg por m²', imagen: 'premium-hoja-silvestre.jpg', agotado: true },
                    { codigo: 'FOL001-05D', nombre: 'Jazmín', formato: 'Rollo 1 m x 3 m', peso: '7.4 kg por m²', imagen: 'premium-jazmin-1x3.jpg' },
                    { codigo: 'FOL032-12D', nombre: 'Follaje en rollo', formato: 'Rollo 1 m x 10 m', peso: '24 kg por rollo', imagen: 'premium-follaje-rollo-1x10.jpg' },
                    { codigo: 'FOL032-18D', nombre: 'Follaje en rollo', formato: 'Rollo 2 m x 5 m', peso: '23.4 kg por rollo', imagen: 'premium-follaje-rollo-2x5.jpg', agotado: true },
                    { codigo: 'FOL032-19D', nombre: 'Follaje en rollo', formato: 'Rollo 2 m x 10 m', peso: '46.8 kg por rollo', imagen: 'premium-follaje-rollo-2x10.jpg', agotado: true },
                    { codigo: 'FOL032-21D', nombre: 'Helecho japonés verde', formato: 'Rollo 1 m x 1 m', peso: '3 kg por m²', imagen: 'premium-helecho-japones-verde-1x1.jpg' }
                ]
            }
        ]
    },
    {
        id: 'follaje-estandar',
        nombre: 'Follaje Estándar',
        descripcion: 'Presupuesto moderado, aspecto natural. Material: LDPE. Alta durabilidad en interior, sin mantenimiento.',
        carpeta: 'follaje-estandar',
        grupos: [
            {
                titulo: null,
                modelos: [
                    { codigo: 'FOL034-01D', nombre: 'Arrayán verde oscuro', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'estandar-arrayan-verde-oscuro.jpg' },
                    { codigo: 'FOL034-01D', nombre: 'Jazmín', formato: 'Panel 60 cm x 40 cm', peso: '400 gr por pieza', imagen: 'estandar-jazmin.jpg' },
                    { codigo: 'FOL035-02D', nombre: 'HS yellow amarillo', formato: 'Panel 60 cm x 40 cm', peso: '380 gr por pieza', imagen: 'estandar-hs-yellow-amarillo.jpg' },
                    { codigo: 'FOL033-01D', nombre: 'HS green verde', formato: 'Panel 60 cm x 40 cm', peso: '380 gr por pieza', imagen: 'estandar-hs-green-verde.jpg' },
                    { codigo: 'FOL043-05D', nombre: 'HS red rojo', formato: 'Panel 60 cm x 40 cm', peso: '380 gr por pieza', imagen: 'estandar-hs-red-rojo.jpg' },
                    { codigo: 'FOL043-06D', nombre: 'ML red rojo', formato: 'Panel 60 cm x 40 cm', peso: '380 gr por pieza', imagen: 'estandar-ml-red-rojo.jpg' },
                    { codigo: 'FOL047-01D', nombre: 'ML morado', formato: 'Panel 60 cm x 40 cm', peso: '380 gr por pieza', imagen: 'estandar-ml-morado.jpg' },
                    { codigo: 'FOL089-01D', nombre: 'Brisa', formato: 'Panel 1 m x 1 m', peso: '3.5 kg por m²', imagen: 'estandar-brisa.jpg' },
                    { codigo: 'FOL085-20D', nombre: 'Florida', formato: 'Panel 1 m x 1 m', peso: '3.4 kg por m²', imagen: 'estandar-florida.jpg' },
                    { codigo: 'FOL032-20D', nombre: 'Magia', formato: 'Panel 1 m x 1 m', peso: '2.6 kg por m²', imagen: 'estandar-magia.jpg' },
                    { codigo: 'FOL034-09D', nombre: 'Helecho', formato: 'Panel 1 m x 1 m', peso: '2.9 kg por m²', imagen: 'estandar-helecho.jpg' },
                    { codigo: 'FOL087-03D', nombre: 'Grecia', formato: 'Panel 1 m x 1 m', peso: '2.7 kg por m²', imagen: 'estandar-grecia.jpg' },
                    { codigo: 'FOL086-08D', nombre: 'Multielementos', formato: 'Panel 1 m x 1 m', peso: '3.2 kg por m²', imagen: 'estandar-multielementos.jpg', agotado: true }
                ]
            }
        ]
    },
    {
        id: 'panel-flores',
        nombre: 'Panel de Flores',
        descripcion: 'Paneles y rollos florales decorativos. Material: Poliéster. Alta durabilidad en interior, sin mantenimiento.',
        carpeta: 'panel-flores',
        grupos: [
            {
                titulo: 'Flores',
                subcarpeta: 'flores',
                modelos: [
                    { codigo: 'FOL040-01F', nombre: 'Palo de rosa con moneda', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-palo-de-rosa-moneda.jpg' },
                    { codigo: 'FOL030-01F', nombre: 'Flor monstera azul', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-monstera-azul.jpg' },
                    { codigo: 'FOL001-01F', nombre: 'Flor monstera blanco', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-monstera-blanco.jpg' },
                    { codigo: 'FOL037-01F', nombre: 'Monstera otoño', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-monstera-otono.jpg' },
                    { codigo: 'FOL039-01F', nombre: 'Monstera', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-monstera.jpg' },
                    { codigo: 'FOL041-01F', nombre: 'Rosas Rosa', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-rosa.jpg' },
                    { codigo: 'FOL045-01F', nombre: 'Rosas lilas', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-lilas.jpg' },
                    { codigo: 'FOL039-02F', nombre: 'Rosas rosas', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-rosas.jpg', agotado: true },
                    { codigo: 'FOL030-02F', nombre: 'Rosas gama azul', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-gama-azul.jpg' },
                    { codigo: 'FOL098-01F', nombre: 'Rosas blancas', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-blancas.jpg' },
                    { codigo: 'FOL043-01F', nombre: 'Rosas rojas', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-rosas-rojas.jpg' },
                    { codigo: 'FOL038-01F', nombre: 'Flores gama durazno', formato: 'Panel 60 cm x 40 cm', peso: '350 gr por pieza', imagen: 'flores-gama-durazno.jpg' }
                ]
            },
            {
                titulo: 'Hojas decorativas en rollo',
                subcarpeta: 'hojas',
                modelos: [
                    { codigo: 'FOL034-04O', nombre: 'Hoja parra oscura', formato: 'Rollo 1 m x 2 m', peso: '580 gr por pieza', imagen: 'hoja-parra-oscura.jpg' },
                    { codigo: 'FOL033-07O', nombre: 'Hoja rosal verde claro', formato: 'Rollo 1 m x 3 m', peso: '580 gr por pieza', imagen: 'hoja-rosal-verde-claro.jpg', agotado: true },
                    { codigo: 'FOL034-05O', nombre: 'Hoja rosal verde oscuro', formato: 'Rollo 1 m x 3 m', peso: '580 gr por pieza', imagen: 'hoja-rosal-verde-oscuro.jpg' },
                    { codigo: 'FOL034-07O', nombre: 'Hoja rosal verde bandera', formato: 'Rollo 1 m x 3 m', peso: '580 gr por pieza', imagen: 'hoja-rosal-verde-bandera.jpg' },
                    { codigo: 'FOL033-06O', nombre: 'Poliéster claro', formato: 'Rollo 1 m x 3 m', peso: '580 gr por pieza', imagen: 'hoja-poliester-claro.jpg' },
                    { codigo: 'FOL034-03O', nombre: 'Hoja rosal verde olivo', formato: 'Rollo 1 m x 3 m', peso: '580 gr por pieza', imagen: 'hoja-rosal-verde-olivo.jpg' },
                    { codigo: 'FOL032-20O', nombre: 'Hoja rosal verde militar', formato: 'Rollo 1 m x 2 m', peso: '580 gr por pieza', imagen: 'hoja-rosal-verde-militar.jpg' }
                ]
            }
        ]
    },
    {
        id: 'expandibles',
        nombre: 'Expandibles',
        descripcion: 'Paneles plegables de instalación rápida tipo acordeón. Materiales: Madera y Poliéster (interior) o Madera y HDPE (interior/exterior). Sin mantenimiento.',
        carpeta: 'expandibles',
        grupos: [
            {
                titulo: 'Madera y Poliéster (interior)',
                modelos: [
                    { codigo: 'FOL085-01O', nombre: 'Hiedra 2 tonos', formato: 'Abierto 45 cm x 1.20 m · Cerrado 20 cm x 70 cm', peso: '1.9 kg por pieza', imagen: 'expandible-hiedra-2-tonos.png' },
                    { codigo: 'FOL034-01O', nombre: 'Hiedra hoja chica', formato: 'Abierto 45 cm x 1.20 m · Cerrado 20 cm x 70 cm', peso: '1.9 kg por pieza', imagen: 'expandible-hiedra-hoja-chica.png' },
                    { codigo: 'FOL034-02O', nombre: 'Hiedra hoja grande', formato: 'Abierto 45 cm x 1.20 m · Cerrado 20 cm x 70 cm', peso: '1.9 kg por pieza', imagen: 'expandible-hiedra-hoja-grande.png' }
                ]
            },
            {
                titulo: 'Madera y HDPE (interior y exterior)',
                modelos: [
                    { codigo: 'FOL043-01D', nombre: 'Laurel rojo', formato: 'Abierto 1 m x 1.20 m · Cerrado 25 cm x 1.20 m', peso: '3 kg por pieza', imagen: 'expandible-laurel-rojo.png' },
                    { codigo: 'FOL036-01D', nombre: 'Limón', formato: 'Abierto 1 m x 1.20 m · Cerrado 25 cm x 1.20 m', peso: '3 kg por pieza', imagen: 'expandible-limon.png' }
                ]
            }
        ]
    },
    {
        id: 'lona',
        nombre: 'Lona',
        descripcion: 'Lona decorativa con estampado de follaje. Material: Nylon y poliéster. Alta durabilidad en interior, sin mantenimiento.',
        carpeta: 'lona',
        grupos: [
            {
                titulo: null,
                modelos: [
                    { codigo: 'VAR032-01X', nombre: 'Lona follaje', formato: '1 m x 2 m', peso: '1 kg por pieza', imagen: 'lona-follaje.jpg' }
                ]
            }
        ]
    }
];

// Deriva una etiqueta corta de presentación a partir del texto de formato,
// para diferenciar de un vistazo modelos que comparten nombre pero cambian de tamaño o presentación.
const getEtiquetaFormato = (formato = '') => {
    if (formato.startsWith('Panel')) return 'Panel';
    if (formato.startsWith('Rollo')) return 'Rollo';
    if (formato.startsWith('Abierto')) return 'Plegable';
    return formato.split(' ')[0];
};

const IconoFormato = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
);

const IconoPeso = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 2a4 4 0 0 1 4 4v2H8V6a4 4 0 0 1 4-4z" />
        <path d="M5 8h14l1.4 11.2A2 2 0 0 1 18.4 21.5H5.6a2 2 0 0 1-2-2.3L5 8z" />
    </svg>
);

const IconoInfo = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 16v-4M12 8h.01" />
    </svg>
);

const FollajeTabs = () => {
    const [activeTab, setActiveTab] = useState(categoriasData[0].id);

    const categoriaActiva = categoriasData.find(cat => cat.id === activeTab);

    // Función para construir la ruta de la imagen
    const getImagePath = (categoria, modelo, subcarpeta = '') => {
        const base = `${process.env.PUBLIC_URL}/assets/img/productos/follaje-artificial/${categoria.carpeta}`;
        if (subcarpeta) {
            return `${base}/${subcarpeta}/${modelo.imagen}`;
        }
        return `${base}/${modelo.imagen}`;
    };

    // Tarjeta de modelo: contenedor de imagen a proporción fija (misma altura en toda la grilla),
    // badge de agotado grande y centrado sobre imagen atenuada en gris, y ficha inferior con iconos.
    const renderModeloCard = (modelo, index, categoria, subcarpeta = '') => {
        const etiqueta = getEtiquetaFormato(modelo.formato);

        return (
            <div key={`${modelo.codigo}-${index}`} className="col-lg-3 col-md-4 col-6 mt-1-9 d-flex">
                <div className="card border-0 shadow-sm h-100 w-100 overflow-hidden">
                    {/* Imagen a proporción fija 4:3, independiente del tamaño original del archivo */}
                    <div className="position-relative" style={{ aspectRatio: '4 / 3', overflow: 'hidden', backgroundColor: '#eef1ee' }}>
                        <img
                            src={getImagePath(categoria, modelo, subcarpeta)}
                            alt={modelo.nombre}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                filter: modelo.agotado ? 'grayscale(1)' : 'none',
                                opacity: modelo.agotado ? 0.55 : 1
                            }}
                        />

                        {/* Etiqueta de presentación (Panel / Rollo / Plegable) */}
                        <span
                            className="position-absolute top-0 start-0 m-2 bg-white text-dark text-uppercase font-weight-700"
                            style={{ fontSize: '11px', letterSpacing: '0.5px', padding: '4px 10px', borderRadius: '4px', boxShadow: '0 1px 4px rgba(0,0,0,0.15)' }}
                        >
                            {etiqueta}
                        </span>

                        {/* Badge de agotado, grande y centrado sobre la imagen atenuada */}
                        {modelo.agotado && (
                            <div
                                className="position-absolute d-flex align-items-center justify-content-center"
                                style={{ inset: 0 }}
                            >
                                <span
                                    className="bg-danger text-white text-uppercase font-weight-800"
                                    style={{
                                        fontSize: '14px',
                                        letterSpacing: '1.5px',
                                        padding: '9px 26px',
                                        borderRadius: '4px',
                                        transform: 'rotate(-6deg)',
                                        boxShadow: '0 3px 10px rgba(0,0,0,0.3)'
                                    }}
                                >
                                    Agotado
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Ficha del modelo, con footer alineado abajo sin importar el largo del nombre */}
                    <div className="d-flex flex-column flex-grow-1 p-1-6">
                        <h3 className="h6 mb-1 font-weight-700">{modelo.nombre}</h3>
                        <p className="mb-0 text-muted" style={{ fontSize: '11px', letterSpacing: '0.3px' }}>{modelo.codigo}</p>

                        <div className="mt-auto pt-2 mt-2 border-top">
                            <div className="d-flex align-items-center text-secondary mb-1">
                                <IconoFormato />
                                <span className="ms-2 text-sm">{modelo.formato}</span>
                            </div>
                            <div className="d-flex align-items-center text-secondary">
                                <IconoPeso />
                                <span className="ms-2 text-sm">{modelo.peso}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <section>
            <div className="container">
                {/* Título de la sección */}
                <div className="row justify-content-center mb-2-3">
                    <div className="col-lg-10 text-center">
                        <div className="title-style2 mb-1-6 wow fadeIn" data-wow-delay="100ms">
                            <h2 className="h1">Elige la categoría de follaje para tu proyecto</h2>
                        </div>
                        <p className="mb-0 text-secondary">
                            Consulta los modelos disponibles por tipo de material y formato
                        </p>
                    </div>
                </div>

                {/* Pestañas */}
                <div className="row justify-content-center mb-2-9">
                    <div className="col-lg-10">
                        <ul className="nav nav-pills justify-content-center flex-wrap" role="tablist">
                            {categoriasData.map((cat) => (
                                <li className="nav-item m-1" key={cat.id}>
                                    <button
                                        className={`nav-link rounded-pill px-3 py-2 ${activeTab === cat.id ? 'active shadow-sm' : 'border'}`}
                                        onClick={() => setActiveTab(cat.id)}
                                        type="button"
                                        role="tab"
                                        style={{ fontSize: '14px', fontWeight: 600 }}
                                    >
                                        {cat.nombre}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Contenido de la categoría activa */}
                {categoriaActiva && (
                    <div className="row">
                        <div className="col-12">
                            {/* Franja de datos generales de la categoría: acento a la izquierda + ícono, en vez de texto plano centrado */}
                            <div
                                className="d-flex align-items-start bg-light rounded p-1-6 p-lg-1-9 mb-2-9"
                                style={{ borderLeft: '4px solid var(--bs-primary, #0d6efd)' }}
                            >
                                <span className="text-primary flex-shrink-0 mt-1">
                                    <IconoInfo />
                                </span>
                                <p className="mb-0 ms-3">{categoriaActiva.descripcion}</p>
                            </div>

                            {/* Grupos de modelos (si tiene subgrupos, los muestra con un separador con etiqueta) */}
                            {categoriaActiva.grupos.map((grupo, idx) => (
                                <div key={idx} className="mb-2-9">
                                    {grupo.titulo && (
                                        <div className="d-flex align-items-center mb-1-6">
                                            <span className="text-primary text-uppercase small letter-spacing-4 font-weight-700 me-3">
                                                {grupo.titulo}
                                            </span>
                                            <span className="flex-grow-1 border-top"></span>
                                        </div>
                                    )}
                                    <div className="row mt-n1-9">
                                        {grupo.modelos.map((modelo, index) =>
                                            renderModeloCard(modelo, index, categoriaActiva, grupo.subcarpeta || '')
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default FollajeTabs;